import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {MatTabsModule} from "@angular/material/tabs";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ComponentesModule} from "@componentes/Componentes.module";
import {TranslateModule} from "@ngx-translate/core";
import {PipesModule} from "@pipes/Pipes.module";
import {AngularSvgIconModule} from "angular-svg-icon";
import {DxBulletModule, DxButtonModule, DxCheckBoxModule, DxContextMenuModule, DxDataGridModule, DxListModule, DxLoadPanelModule, DxSelectBoxModule, DxTemplateModule, DxTreeViewModule, DxValidationSummaryModule, DxValidatorModule} from "devextreme-angular";
import {GlobalModule} from "../global/global.module";

import {EvaluacionesPendientesRoutingModule} from "./evaluacionpendiente-routing.module";
import {ColaboradorComponent} from "./colaborador/colaborador.component";
import {EvaluacionPendienteColaboradorIntermedioComponent} from "./colaborador/colaboradorintermedio.component";
import {ConfiguracionComponent} from "./configuracion/configuracion.component";
import { EjecucionEvaluacionComponent } from "./ejecucionevaluacion/ejecucionevaluacion.component";
import { EjecucionEvaluacionEliminacionComponent } from "./ejecucionevaluacion/ejecucionevaluacioneliminacion/ejecucionevaluacioneliminacion.component";
import { AdministracionAcuerdoComponent } from "./administracionacuerdo/administracionacuerdo.component";




@NgModule({
    declarations: [
        ColaboradorComponent,
        EvaluacionPendienteColaboradorIntermedioComponent,
        ConfiguracionComponent,
        EjecucionEvaluacionComponent,
        EjecucionEvaluacionEliminacionComponent,
        AdministracionAcuerdoComponent
    ],
    entryComponents: [
        EvaluacionPendienteColaboradorIntermedioComponent,
        EjecucionEvaluacionEliminacionComponent
    ],
    imports: [
        CommonModule,
        ComponentesModule,
        TranslateModule,
        FormsModule,
        MatTooltipModule,
        MatTabsModule,
        DxDataGridModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxValidationSummaryModule,
        DxButtonModule,
        DxValidatorModule,
        DxBulletModule,
        DxLoadPanelModule,
        DxTreeViewModule,
        DxListModule,
        AngularSvgIconModule,
        DxContextMenuModule,
        DxTemplateModule,
        PipesModule,
        EvaluacionesPendientesRoutingModule,
        GlobalModule
    ]
})
export class EvaluacionesPendientesModule {}
